import React from 'react';

import {
  IconAdjust,
  IconBasketOutline,
  IconPackageOpen,
  IconQuestionMarkOutline,
  IconWallet,
} from '@iwoca/icons';
import { GetSellerPayLinkResponse } from '@iwoca/lapi-client/iwocapay';
import { clsx } from 'clsx';

import LightningBolt from '../../../../../Integrations/assets/lightningBolt.svg';
import MagentoLogo from '../../../../../Integrations/assets/magentoLogo.svg';
import OpenCartLogo from '../../../../../Integrations/assets/opencartLogo.svg';
import QuickBooksLogo from '../../../../../Integrations/assets/quickBooksLogo.svg';
import ShopifyLogo from '../../../../../Integrations/assets/shopifyLogo.svg';
import WooCommLogo from '../../../../../Integrations/assets/wooLogo.svg';
import XeroLogo from '../../../../../Integrations/assets/xeroLogo.svg';
import { PayLinkColumns } from '../../PayLinkTable';

export const PayLinkSource = ({
  payLink,
  className = null,
}: {
  payLink: PayLinkColumns;
  className?: string | null;
}): React.ReactNode => {
  const names: {
    [k: GetSellerPayLinkResponse['data'][number]['source']]:
      | string
      | React.ReactNode;
  } = {
    Unknown: 'Unknown',
    iwocaPay: 'Custom',
    Xero: 'Xero',
    iwocaPayMe: 'Universal',
    iwocaPay_pay_link_package: 'Package',
    iwocaPay_ecommerce_api: 'API',
    iwocaPay_woocommerce_extension: 'WooComm',
    iwocaPay_quickbooks: 'Quickbooks',
    iwocaPay_magento_extension: 'Magento',
    iwocaPay_opencart_extension: 'OpenCart',
    iwocaPay_shopify_payment_app: (
      <div>
        Shopify
        <div className="w-[90px] max-w-full break-words text-xs font-reg text-structure-40">
          {payLink.shopify_payment_id}
        </div>
      </div>
    ),
  };

  const icons: {
    [k: GetSellerPayLinkResponse['data'][number]['source']]: React.ReactNode;
  } = {
    Unknown: <IconQuestionMarkOutline />,
    iwocaPay: <IconAdjust />,
    Xero: <img src={XeroLogo} alt="Xero logo" />,
    iwocaPayMe: <IconWallet />,
    iwocaPay_pay_link_package: <IconPackageOpen />,
    iwocaPay_ecommerce_api: <IconBasketOutline />,
    iwocaPay_woocommerce_extension: (
      <img src={WooCommLogo} alt="WooCommerce logo" />
    ),
    iwocaPay_quickbooks: <img src={QuickBooksLogo} alt="Quickbooks logo" />,
    iwocaPay_magento_extension: <img src={MagentoLogo} alt="Magento logo" />,
    iwocaPay_opencart_extension: <img src={OpenCartLogo} alt="Opencart logo" />,
    iwocaPay_shopify_payment_app: <img src={ShopifyLogo} alt="Shopify logo" />,
  };

  // funded_via is only PAY_NOW once a payment executes; a failed session has no
  // funded_via, so key off the status too to label failed Pay Now links.
  if (payLink.funded_via === 'PAY_NOW' || payLink.status === 'PAY_NOW_FAILED') {
    return (
      <div
        className={clsx(
          'grid grid-cols-[24px_auto] items-center gap-s [&_img]:h-auto [&_img]:w-[20px] [&_svg]:h-auto [&_svg]:w-[20px]',
          className,
        )}
      >
        <img src={LightningBolt} alt="" />
        <div>Pay Now</div>
      </div>
    );
  }

  return (
    <div
      className={clsx(
        'grid grid-cols-[24px_auto] items-center gap-s [&_img]:h-auto [&_img]:w-[20px] [&_svg]:h-auto [&_svg]:w-[20px]',
        className,
      )}
    >
      {icons[payLink.source] || '?'}
      <div>{names[payLink.source] || 'Unknown'}</div>
    </div>
  );
};
